/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { getAuthToken } from '@/utils/auth.utils'
import HttpRequest from './http-request'

class StockLocationProvider extends HttpRequest {
  mappingLocation (payload: any): Promise<any> {
    this.setHeader(getAuthToken())
    return this.create('/stock-location/mapping', payload)
  }

  decrementMappingQty (payload: any): Promise<any> {
    this.setHeader(getAuthToken())
    return this.patch('/stock-location/mapping/decrement-mapping-qty', payload)
  }

  moveLocation (payload: any): Promise<any> {
    this.setHeader(getAuthToken())
    return this.patch('/stock-location/mapping/move-location', payload)
  }

  getProductLocation (payload: any): Promise<any> {
    this.setHeader(getAuthToken())
    return this.get('/stock-location/mapping/code', payload)
  }

  getLocationById (id: string, query = {}): Promise<any> {
    this.setHeader(getAuthToken())
    return this.get(`/stock-location/master/${id}`, query)
  }

  getMappingLocationPaginate (query: any) {
    this.setHeader(getAuthToken())
    return this.get('/stock-location/mapping', query)
  }

  createPickWnDraft (payload: any) {
    this.setHeader(getAuthToken())
    return this.create('/stock-location/pick-draft', payload)
  }

  getPickWnDraftByCode (wnCode: any) {
    this.setHeader(getAuthToken())
    return this.get(`/stock-location/pick-draft/${wnCode}`)
  }

  updatePickWnDraftByCode (wnCode: string, payload: any) {
    this.setHeader(getAuthToken())
    return this.patch(`/stock-location/pick-draft/${wnCode}`, payload)
  }

  finishedPickWnDraftByCode (wnCode: string, payload: any) {
    this.setHeader(getAuthToken())
    return this.patch(`/stock-location/pick-draft/${wnCode}/finished`, {})
  }

  deletePickWnDraftByCode (wnCode: string) {
    this.setHeader(getAuthToken())
    return this.delete(`/stock-location/pick-draft/${wnCode}`)
  }
}

export default StockLocationProvider
